import { apolloClient } from '@/graphql/apollo'
import { ApolloProvider } from '@apollo/client'
import * as Sentry from '@sentry/react'
import React from 'react'
import { BrowserRouter as Router } from 'react-router-dom'
import { Footer } from '../shared/components/Footer'
import Routes from './Routes'
import { AuthProvider } from './components/AuthProvider'
import { Menu } from './components/container/Menu'
import '../config/dayjs'

function FallbackComponent() {
  return <div>An error has occured</div>
}

export const App: React.FC = () => {
  return (
    <Sentry.ErrorBoundary fallback={FallbackComponent} showDialog>
      <ApolloProvider client={apolloClient}>
        <AuthProvider>
          <Router>
            <Menu />
            <Routes />
            <Footer />
          </Router>
        </AuthProvider>
      </ApolloProvider>
    </Sentry.ErrorBoundary>
  )
}
